export default interface IRootState {
  customSubdomain: string | null;
}

export const initializeState = (): IRootState => ({
  customSubdomain: null,
});
